export const routes = {
  LANDING: '/',
  PANEL: '/panel',
  POLL_TOKENS: '/panel/tokens/:pollId',
  POLL_VOTE: '/vote/:poll_token',
  POLL_DETAILS: '/details/:id',
  POLL_EDIT: '/edit/:id',
  POLL_CREATE: '/create',
};
